<template>
  <div>
    <h4>New pending</h4>

    <form @submit.prevent="addPending">
      <div class="form-group">
        <label for="purpose-selector">Type</label>
        <b-form-select
          id="purpose-selector"
          v-model="purpose"
          :options="purposeOptions"
          autofocus
        />
      </div>

      <component
        ref="dataInputComponent"
        v-bind:is="dataInputComponentType"
      />

      <b-button :to="{name: 'player_pendings'}">Cancel</b-button>

      <b-button
        v-if="isPurposeImplemented"
        type="submit"
        variant="primary">
        Add
      </b-button>
    </form>
  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';
import VueBootstrapTypeahead from './VueBootstrapTypeahead.vue';

import { PURPOSE_REWARD_LETTER                    } from '../model/pending.js';
import { PURPOSE_RESTORE_PAYMENT_BY_SKU           } from '../model/pending.js';
import { PURPOSE_REWIND_STORY_TO_QUEST            } from '../model/pending.js';
import { PURPOSE_REWIND_M3_MAIN_SEQUENCE          } from '../model/pending.js';
import { PURPOSE_FORCE_SPECIAL_OFFER              } from '../model/pending.js';
import { PURPOSE_FORCE_APPLY_MIGRATION            } from '../model/pending.js';
import { PURPOSE_TRANSFER_CLUB_OWNERSHIP_RECEIVED } from '../model/pending.js';
import { PURPOSE_TRANSFER_CLUB_OWNERSHIP_LOST     } from '../model/pending.js';
import { PURPOSE_FOLLOWING_LINK                   } from '../model/pending.js';
import { PURPOSE_FOR_VIP                          } from '../model/pending.js';

import PlayerPendingAddDataInputNotImplemented      from './PlayerPendingAddDataInputNotImplemented.vue';
import PlayerPendingAddDataInputRewardLetter        from './PlayerPendingAddDataInputRewardLetter.vue';
import PlayerPendingAddDataInputRestorePaymentBySKU from './PlayerPendingAddDataInputRestorePaymentBySKU.vue';
import PlayerPendingAddDataInputRewindStoryToQuest  from './PlayerPendingAddDataInputRewindStoryToQuest.vue';
import PlayerPendingAddDataInputForceSpecialOffer   from './PlayerPendingAddDataInputForceSpecialOffer.vue';
import PlayerPendingAddDataInputForceApplyMigration from './PlayerPendingAddDataInputForceApplyMigration.vue';
import PlayerPendingAddDataInputFollowingLink       from './PlayerPendingAddDataInputFollowingLink.vue';
import PlayerPendingAddDataInputRewardForVip        from './PlayerPendingAddDataInputRewardForVip.vue';

import { getEnumPendingPurposeValues } from '../autogen/bundle.js';
import { getEnumPendingPurposeName   } from '../autogen/bundle.js';

export default {
  name: 'PlayerPendingAdd',

  components: {
    VueBootstrapTypeahead,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    const purposeOptions = getPurposeOptions();

    return {
      purposeOptions: purposeOptions,
      purpose: purposeOptions[0].value,
    };
  },

  computed: {
    dataInputComponentType() {
      switch(this.purpose) {
        case PURPOSE_REWARD_LETTER:                    return PlayerPendingAddDataInputRewardLetter;
        case PURPOSE_RESTORE_PAYMENT_BY_SKU:           return PlayerPendingAddDataInputRestorePaymentBySKU;
        case PURPOSE_REWIND_STORY_TO_QUEST:            return PlayerPendingAddDataInputRewindStoryToQuest;
        case PURPOSE_REWIND_M3_MAIN_SEQUENCE:          return PlayerPendingAddDataInputNotImplemented;
        case PURPOSE_FORCE_SPECIAL_OFFER:              return PlayerPendingAddDataInputForceSpecialOffer;
        case PURPOSE_FORCE_APPLY_MIGRATION:            return PlayerPendingAddDataInputForceApplyMigration;
        case PURPOSE_TRANSFER_CLUB_OWNERSHIP_RECEIVED: return null;
        case PURPOSE_TRANSFER_CLUB_OWNERSHIP_LOST:     return null;
        case PURPOSE_FOLLOWING_LINK:                   return PlayerPendingAddDataInputFollowingLink;
        case PURPOSE_FOR_VIP:                          return PlayerPendingAddDataInputRewardForVip;
      }
      return PlayerPendingAddDataInputNotImplemented;
    },

    isPurposeImplemented() {
      return this.dataInputComponentType !== PlayerPendingAddDataInputNotImplemented;
    },
  },

  methods: {
    addPending() {
      notifier.deleteSenderNotifications(this);

      const url = '/player/' + this.playerId + '/pending/add';

      const dataResult = this.getFormData();
      if(dataResult.error !== null) {
        notifier.showError(dataResult.error, {sender: this});
        return;
      }
      const data = dataResult.data;

      HTTP.post(url, data)
      .then(() => {
        notifier.showSuccessAfterTransition('Pending added.');
        this.$router.push({name: 'player_pendings'});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      })
    },

    getFormData() {
      const data = new FormData();
      data.append('purpose', this.purpose);

      const dataInputComponent = this.$refs.dataInputComponent;
      if(dataInputComponent === undefined) {
        return {data: data, error: null};
      }

      const err = dataInputComponent.fillFormData(data);
      if(err !== null) {
        return {data: null, error: err};
      }

      return {data: data, error: null};
    },
  },
}

function getPurposeOptions() {
  const options = [];

  const values = getEnumPendingPurposeValues();
  for(const value of values) {
    const name = getEnumPendingPurposeName(value);
    const option = {
      value: value,
      text: name,
    };
    options.push(option);
  }

  return options;
}

</script>
